import { configureStore } from '@reduxjs/toolkit';
import { medusaApi } from '../services/api';
import cartReducer from './cartSlice';
import uiReducer from './uiSlice';

export const store = configureStore({
  reducer: {
    [medusaApi.reducerPath]: medusaApi.reducer,
    cart: cartReducer,
    ui: uiReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [medusaApi.util.resetApiState.type],
      },
    }).concat(medusaApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;